export const formConstants = {
  SOURCE_ORG_ID: 'srcOrgId',
  DEST_ORG_ID: 'dstOrgId',
  EMERGENCY: 'emergency',
  PATIENT_NAME: 'patientName',
  PATIENT_GENDER: 'patientGender',
  DEPARTMENT: 'department',
};
